document.addEventListener("DOMContentLoaded", function () {
  const showBtn = document.getElementById("show-return-popup");
  const overlay = document.getElementById("return-popup-overlay");
  const closeBtn = document.querySelector(".popup-close");
  if (showBtn && overlay) {
    showBtn.addEventListener("click", function (e) {
      e.preventDefault();
      overlay.style.display = "flex";
    });
  }
  if (closeBtn && overlay) {
    closeBtn.addEventListener("click", function () {
      overlay.style.display = "none";
    });
  }
  if (overlay) {
    window.addEventListener("click", function (e) {
      if (e.target.id === "return-popup-overlay") {
        overlay.style.display = "none";
      }
    });
  }
  function enableButton(checkboxId, buttonId) {
    const checkbox = document.getElementById(checkboxId);
    const button = document.getElementById(buttonId);
    if (!checkbox || !button) return;
    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        button.style.pointerEvents = "auto";
        button.style.opacity = "1";
      } else {
        button.style.pointerEvents = "none";
        button.style.opacity = "0.5";
      }
    });
  }
  enableButton("accept-return-fees-fr", "submit-return-fr");
  enableButton("accept-return-fees-en", "submit-return-en");
  enableButton("accept-return-fees-ar", "submit-return-ar");
});